<script>
  import ProjectVoiceCaseItems from "./ProjectVoiceCaseItems.svelte";

</script>

<div class="spacing:bottom:32">
  <ProjectVoiceCaseItems limit={3} enableShowMore={false}/>
</div>

<div class="block:center spacing:bottom:16">
  <a href="/project/voice/" class="owd-button owd-button:large owd-button:primary">「声がカタチに」の事例を見る</a>
</div>
